import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'

type HistorySkeletonVariant = 'dark' | 'light'

@Component({
  selector: 'app-invitation-channel-history-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, NgClass],
  templateUrl: './invitation-channel-history-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tw-flex tw-w-full tw-flex-col tw-overflow-hidden',
    '[style.height]': "'100px'"
  }
})
export class InvitationChannelHistorySkeletonComponent {
  public readonly count = input(1)
  public readonly variant = input<HistorySkeletonVariant>('light')

  public readonly rows = computed(() => Array.from({ length: Math.max(1, this.count()) }, (_, index) => index))

  public readonly dateTheme = computed(() => this._theme(120, 12))
  public readonly badgeTheme = computed(() => this._theme(56, 16))
  public readonly byTheme = computed(() => this._theme(88, 10))

  private _theme(width: number, height: number): Record<string, string | number> {
    const isDark = this.variant() === 'dark'
    return {
      width: `${width}px`,
      height: `${height}px`,
      'margin-bottom': '0',
      'border-radius': '4px',
      background: isDark ? '#4B5563' : '#E5E7EB'
    }
  }
}
